import Reveal from '@/components/base/Reveal';
import { quickActions } from '@/mocks/site';

const toneStyles = {
  primary: 'bg-primary-500 text-background-50 hover:bg-primary-600',
  secondary: 'bg-secondary-500 text-background-50 hover:bg-secondary-600',
} as const;

export default function QuickActions() {
  return (
    <section className="bg-background-50 px-5 py-14 pr-14 md:px-10 md:py-20 md:pr-20">
      <div className="mx-auto max-w-6xl">
        <Reveal variant="up" className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-[10px] en-label text-primary-600">JOIN US</p>
            <h2 className="mt-3 font-heading text-[22px] font-black leading-tight text-foreground-950 md:text-[30px]">
              出店も、協賛も。<br className="sm:hidden" />一緒につくる人を募集しています。
            </h2>
          </div>
          <p className="max-w-md text-[12.5px] leading-[1.9] text-foreground-600 md:text-right">
            お店の味を届けたい方、地域を盛り上げたい企業さま。どちらのご相談も、まずはお気軽にご連絡ください。
          </p>
        </Reveal>

        <div className="mt-8 grid gap-3 md:mt-10 md:grid-cols-2 md:gap-4">
          {quickActions.map((action, index) => (
            <Reveal key={action.id} variant={index === 0 ? 'left' : 'right'} delay={index * 120}>
              <a
                href={action.href}
                className={`group relative flex h-full min-h-[210px] cursor-pointer flex-col justify-between overflow-hidden rounded-lg p-6 transition-all duration-500 hover:-translate-y-1 md:min-h-[248px] md:p-8 ${toneStyles[action.tone]}`}
              >
                <span className="pointer-events-none absolute -bottom-8 -right-2 flex h-40 w-40 items-center justify-center text-white/10 md:h-52 md:w-52">
                  <i className={`${action.icon} text-[150px] leading-none md:text-[190px]`} aria-hidden="true" />
                </span>

                <div className="relative flex items-start justify-between gap-4">
                  <span className="text-[10px] en-label opacity-85">{action.kicker}</span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/35 md:h-12 md:w-12">
                    <i className={`${action.icon} text-[18px] md:text-xl`} aria-hidden="true" />
                  </span>
                </div>

                <div className="relative mt-8">
                  <h3 className="font-heading text-[24px] font-black leading-tight md:text-[32px]">{action.title}</h3>
                  <p className="mt-2.5 max-w-sm text-[12.5px] leading-relaxed opacity-85 md:text-[13px]">{action.lead}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-[12px] font-bold">
                    詳しく見る
                    <i
                      className="ri-arrow-right-line transition-transform duration-500 group-hover:translate-x-1"
                      aria-hidden="true"
                    />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}